export default "__VITE_ASSET__DdAsKpbC__"